/**
 * 通用校验规则
 */

/**
 * 校验手机号
 * @param {string} value
 * @returns {boolean}
 */
export function isMobile(value) {
  return /^1[3-9]\d{9}$/.test(value)
}

/**
 * 校验邮箱
 * @param {string} value
 * @returns {boolean}
 */
export function isEmail(value) {
  return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value)
}

/**
 * 校验身份证号
 * @param {string} value
 * @returns {boolean}
 */
export function isIdCard(value) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)
}

/**
 * 校验用户名（4-20位字母数字下划线）
 * @param {string} value
 * @returns {boolean}
 */
export function isUsername(value) {
  return /^[a-zA-Z0-9_]{4,20}$/.test(value)
}

/**
 * Element UI 表单校验器：手机号
 */
export const mobileValidator = (rule, value, callback) => {
  if (value && !isMobile(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

/**
 * Element UI 表单校验器：邮箱
 */
export const emailValidator = (rule, value, callback) => {
  if (value && !isEmail(value)) {
    callback(new Error('请输入正确的邮箱地址'))
  } else {
    callback()
  }
}

/**
 * 校验密码强度（大写字母+小写字母+数字+特殊符号，长度8位以上）
 * @param {string} value
 * @returns {boolean}
 */
export function isStrongPassword(value) {
  return typeof value === 'string' &&
    value.length >= 8 &&
    /[A-Z]/.test(value) &&
    /[a-z]/.test(value) &&
    /\d/.test(value) &&
    /[^A-Za-z0-9]/.test(value)
}

/**
 * Element UI 表单校验器：密码强度
 */
export const passwordValidator = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }
  if (value.length < 8) {
    callback(new Error('密码长度不能少于8位'))
  } else if (!/[A-Z]/.test(value)) {
    callback(new Error('密码必须包含大写字母'))
  } else if (!/[a-z]/.test(value)) {
    callback(new Error('密码必须包含小写字母'))
  } else if (!/\d/.test(value)) {
    callback(new Error('密码必须包含数字'))
  } else if (!/[^A-Za-z0-9]/.test(value)) {
    callback(new Error('密码必须包含特殊符号'))
  } else {
    callback()
  }
}
